/**
 * Paths available to users who are not logged in
 * @constant
 */
// import adminDashboardLayout from "pages/adminDashboard/adminDashboardLayout";

export const PUBLIC_PATHS = {
  LOGIN: "/user/login",
  REGISTER: "/user/register",
  FORGOT_PASS: "/user/forgot-password",
  RESET_PASSWORD: "/user/reset-password",
  LOGOUT: "/user/logout",
  SINGLE_SCRIPT: "/scripts/:slug",
  DASHBOARD: "/dashboard",
  SEARCH_RESULT: "/search/:text",
};

export const PROTECTED_PATHS = {
  UPLOAD: "/uploads",
  OLD_UPLOAD_ADMIN: "/old-uploads-admin",
  USERS_CATEGORY: "/users-category",
  REGISTERED_USERS: "/registered-users",
  VERIFIED_USERS: "/verified-users",
  SUBSCRIBED_USERS: "/subscribed-users",
  ACTIVE_USERS: "/active-users",
  REVENUE: "/revenue",
  WEEKLY_DOWNLOADS: "/downloads",
  TOTAL_REVENUE: "/totalrevenue",
  REVENUE_USD: "usd",
  REVENUE_NGN: "ngn",
  APPROVED_SCRIPTS: "/approved-scripts",
  SUBSCRIBERS: "/subscribers",
  UPLOAD_ADMIN: "/uploads-admin",
  TEST_ADMIN: "/test-uploads-admin",
  NEW_EDIT_SCRIPT: "/new-edit-script",
  DASHBOARD: "/dashboard",
  SINGLE_SCRIPT: "/scripts/:slug",
  SEARCH_RESULT: "/search/:text",
  COMPOSER: "/composer",
  NEW_COMPOSER: "/composer/new",
  ALL_COMPOSER: "/all-composer",
  EDIT_COMPOSER: "/composer/:id",
};
